import * as API from '../api/AuthApi';

export function login(username, password) {
  return API.login(username, password);
}

export function logout() {
  API.logout();
}

export function getUser() {
  return API.getUser();
}

export function getMyProfile() {
  return API.getMyProfile();
}
